export enum CustomerAddressSortType {
    Id,
    DistrictName,
    ProvinceName,
    CountryName,
    PostalCode,
    Description,
    CustomerName,
    CustomerAddressType,
    IsDeleted
}
